import { Text } from 'ui-kit/typography'
import ImageMob1x from './flows-mob1x.png'
import ImageMob2x from './flows-mob2x.png'
import ImageDesk1x from './flows-desk1x.png'
import ImageDesk2x from './flows-desk2x.png'
import classes from './DifferenceFlows.module.scss'

export const DifferenceFlows = () => {
  return (
    <article className={classes.article}>
      <div className={classes.heading}>
        <Text size={'lg'} center balance className={classes.tagline}>
          Flows are not for every use case
        </Text>
        <Text size={'lg'} center balance className={classes.subtitle}>
          While flow is the most generic way of building integrations, it does
          not work well for every use case. If you want to read a whole data
          collection or implement type-ahead search in your Ul, flows just don't
          work.
        </Text>
      </div>

      <div className={classes.visual}>
        <picture className={classes.image}>
          <source
            media='(min-resolution: 2dppx) and (min-width: 768px)'
            srcSet={ImageDesk2x.src}
          />
          <source media='(min-width: 768px)' srcSet={ImageDesk1x.src} />
          <source
            media='(min-resolution: 2dppx) and (max-width: 767px)'
            srcSet={ImageMob2x.src}
          />
          <source media='(max-width: 767px)' srcSet={ImageMob1x.src} />
          <img
            src={ImageMob1x.src}
            alt='Flows are not for every use case'
            loading='lazy'
          />
        </picture>
      </div>
    </article>
  )
}
